/** Кнопка отзыва: под кнопкой языка, на десктопе в правой колонке. Открывает окно отзыва. */
import { useT } from "./hooks";
import { openWindow } from "./store";
import "./language.css";

export function FeedbackButton() {
  const t = useT();
  const label = t("win.feedback.title");
  return (
    <button
      type="button"
      class="feedback-button"
      data-testid="feedback-button"
      aria-label={label}
      title={label}
      onClick={() => openWindow({ kind: "feedback" })}
    >
      <svg viewBox="0 0 24 24" width="21" height="21" aria-hidden="true">
        <path d="M4 5h16a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H10l-4 4v-4H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1Z" fill="#fff" />
        <circle cx="8.3" cy="11" r="1.3" fill="#27344f" />
        <circle cx="12" cy="11" r="1.3" fill="#27344f" />
        <circle cx="15.7" cy="11" r="1.3" fill="#27344f" />
      </svg>
    </button>
  );
}
